import * as React from "react";
import { IFormFieldProps, SelectListField } from "./editors";
import * as M from "../../models";
import { FieldTypes } from "../../models/formBuilder";
import * as Editors from "../editors";

type OwnProps = IFormFieldProps & {
};

interface OwnState {
}

export class FieldEditor extends React.Component<OwnProps, OwnState> {
    public render() {
        const f = this.props.field;
        const form = this.props.formComponent;
        const name = M.FormBuilder.FormSubmissionHelper.getFieldName(this.props.namePrefix || "", this.props.sectionIndex, f.index);

        const formFieldProps: Editors.FormFieldProps = {
            description: f.description
                ? <div dangerouslySetInnerHTML={{ __html: f.description }} />
                : undefined,
            hint: f.typeId === FieldTypes.RichText.id ? undefined : f.hint,
            labelHint: f.typeId === FieldTypes.RichText.id ? f.hint : undefined,
            label: f.label,
            name,
            required: f.required,
        };

        const hasMinOrMax = (f.max || -1) >= 0 || (f.min || -1) >= 0;
        let field: JSX.Element | null = null;
        switch (f.typeId) {
            case FieldTypes.Checkbox.id:
                field = <Editors.CheckboxField formComponent={form} css={f.css} { ...formFieldProps } />;
                break;
            case FieldTypes.CheckList.id:
            case FieldTypes.Dropdown.id:
            case FieldTypes.RadioList.id:
                field = <SelectListField { ...this.props } />;
                break;
            // case FieldTypes.Date.id:
            // case FieldTypes.DateTime.id:
            //     field = <Editors.DateField formComponent={form} css={f.css} { ...formFieldProps } />;
            //     break;
            case FieldTypes.EmailAddress.id:
                field = <Editors.EmailField formComponent={form} css={f.css} placeholder={f.placeholder} { ...formFieldProps } />;
                break;
            case FieldTypes.Integer.id:
                field = <Editors.NumberField formComponent={form} css={f.css} placeholder={f.placeholder} { ...formFieldProps } />;
                break;
            case FieldTypes.MultilineText.id:
                field = <Editors.TextAreaField formComponent={form} css={f.css} placeholder={f.placeholder} { ...formFieldProps } />;
                break;
            case FieldTypes.Number.id:
                field = <Editors.NumberField formComponent={form} css={f.css} placeholder={f.placeholder} { ...formFieldProps } />;
                break;
            case FieldTypes.RichText.id:
                field = <Editors.RichTextField
                    formComponent={form}
                    css={f.css}
                    { ...formFieldProps }
                    options={M.Abstract.DetailsTinymceOptions({
                        statusbar: hasMinOrMax,
                        characterlimit_max: f.isWordsRange ? undefined : f.max,
                        characterlimit_min: f.isWordsRange ? undefined : f.min,
                        wordlimit_max: f.isWordsRange ? f.max : undefined,
                        wordlimit_min: f.isWordsRange ? f.min : undefined,
                    }, hasMinOrMax
                        ? (f.isWordsRange ? "wordcountsimple wordlimit" : "charactercount characterlimit")
                        : "")}
                />;
                break;
            case FieldTypes.Text.id:
                field = <Editors.TextField formComponent={form} css={f.css} placeholder={f.placeholder} { ...formFieldProps } />;
                break;
            case FieldTypes.TimeSpan.id:
            case FieldTypes.TimeSpanMinutes.id:
                field = <Editors.TextField formComponent={form} css={f.css} placeholder={f.placeholder} { ...formFieldProps } />;
                break;
        }

        return field;
    }
}



// WEBPACK FOOTER //
// ./src/components/formBuilder/FieldEditor.tsx